import { __module as e } from "./index781.js";
var f = e.exports, i;
function m() {
  return i ? e.exports : (i = 1, (function(s, u) {
    (function(n, r) {
      s.exports = r();
    })(f, (function() {
      return function(n, r) {
        r.prototype.isSameOrBefore = function(o, t) {
          return this.isSame(o, t) || this.isBefore(o, t);
        };
      };
    }));
  })(e), e.exports);
}
export {
  m as __require
};
